import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { tap, catchError, timeout, switchMap } from 'rxjs/operators';
import { NzMessageService } from 'ng-zorro-antd/message';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { LoginService } from '../services/login.service';
import { TranslateService } from '@ngx-translate/core';
import { SharedDataService } from 'src/app/services/sharedDataService.service';
import { CustomerService } from 'src/app/services/customer.service';
const BASE_PATH: string = environment.requestUrl;
const USER_CENTER_PATH: string = environment.userCenterUrl;
const USER_CENTER_ADMIN_PATH: string = environment.userCenterAdminUrl;
const DEALER_PORTAL_PATH: string = environment.dealerPortalUrl;
const ECAT_PORTAL_PATH: string = environment.ecatUrl;


@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {
  isDealerPortal: boolean = false;
  constructor(
    private message: NzMessageService,
    private router: Router,
    private loginService:LoginService,
    private translate:TranslateService,
    private sharedData: SharedDataService,
    private customerService: CustomerService
  ) {
    this.sharedData.currentData.subscribe(data => {
      this.isDealerPortal = data.isDealerPortal;
    });
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // 排除新闻静态资源请求，避免自定义头触发 CORS 预检失败
    const isNewsStaticRequest = request.url.startsWith(environment.newsStaticUrl);
    if (isNewsStaticRequest) {
      const cleanRequest = request.clone({
        headers: request.headers.delete('isEcat').delete('isUserCenter').delete('isUserCenterAdmin').delete('isDealerPortal')
      });
      return next.handle(cleanRequest).pipe(timeout(300000));
    }

    // Hold requests carrying CUSTOMER-CODE until the stored customer is confirmed still bound to the user
    const needsCustomerCheck = !!localStorage.getItem('customer')
      && !request.headers.has('skipCustomerCode')
      && !request.url.includes('assets/');
    if (needsCustomerCheck) {
      return this.customerService.ensureValidCustomer().pipe(
        switchMap(() => this.handleRequest(request, next))
      );
    }
    return this.handleRequest(request, next);
  }

  private handleRequest(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isEcatRequest = request.headers.has('isEcat');
    let ecatRequest = request.clone({ setHeaders: { "Accept": "application/json" } })
    const token = localStorage.getItem('token') || '';
    const config: any = localStorage.getItem('template_config') || '{}';
    const { language = 'zh'} = JSON.parse(config);
    let systemId = '6';
    if(!this.isDealerPortal) {
      systemId = '8'
    }
    request = request.clone({
      setHeaders: { token,"Accept-Language":language=='en'?'en-US':'zh-CN','X-APP-SYSTEM':systemId}
    });

    if (token) {
      request = request.clone({
        setHeaders: { token }
      });
    }
    const customer = localStorage.getItem('customer');
    const skipCustomerCode = request.headers.has('skipCustomerCode');
    if (skipCustomerCode) {
      request = request.clone({ headers: request.headers.delete('skipCustomerCode') });
      ecatRequest = ecatRequest.clone({ headers: ecatRequest.headers.delete('skipCustomerCode') });
    }
    // request = request.clone({
    //   // customer-code:0191100210/ org:AU20-G1-40  --- 调试achievement
    //   setHeaders: { 'CUSTOMER-CODE': '0191100210' }
    // });
    if(customer && !skipCustomerCode){
      request = request.clone({
        setHeaders: { 'CUSTOMER-CODE': JSON.parse(customer).customerCode}
      });
    }
    const orgs = ["/iam", "/oes"];
    const matchedOrg = orgs.find(org => window.location.pathname.includes(org));
    if (matchedOrg && token !== '') {
      request = request.clone({
        setHeaders: { "ORG":this.getOrgCode(matchedOrg)}
      });
    }else{
      // unlogin && no /iam or /oes
      request = request.clone({
        setHeaders: { "ORG":'CN20-G1-40'}
      });
    }
    if (!request.url.includes('.json?v=') && !request.url.endsWith('.svg') && !request.url.startsWith('http')) {
      if (request.headers.has('isUserCenter')) {
        request = request.clone({
          url: `${ USER_CENTER_PATH }${ request.url }`,
        });
      }else if(request.headers.has('isUserCenterAdmin')){
        request = request.clone({
          url: `${ USER_CENTER_ADMIN_PATH }${ request.url }`,
        });
      }else if(isEcatRequest){
        request = request.clone({
          url: `${ ECAT_PORTAL_PATH }${ request.url }`,
        });
      }else if(request.headers.has('isDealerPortal')){
        request = request.clone({
          url: `${ DEALER_PORTAL_PATH }${ request.url }`,
        });
      }else{
        request = request.clone({
          url: `${ BASE_PATH }${ request.url }`,
          setHeaders: {'X-APP-SYSTEM':systemId}
        });
      }
      request = request.clone({
        url: request.url
      });

      ecatRequest = ecatRequest.clone({
        url: request.url
      });
    }
    const finalRequest = isEcatRequest ? ecatRequest : request;
    const finalReq = finalRequest.clone({
      headers: finalRequest.headers.delete('isEcat')
    });
    const timeoutValue = 300000;
    return next.handle(finalReq).pipe(
      timeout(timeoutValue),
      tap(res => {
        if (res instanceof HttpResponse) {
          if (isEcatRequest) {

          } else {
            const { rtnCode, rtnMsg, code, message } = res.body || {};
            // code为10000时请求成功， 10001是token过期
            // 请求翻译文件返回格式没有rtnCode， 判断中去除
            // 请求导出文件返回格式没有rtnCode， 判断中去除
            // 10001,10003,10002,200003 token error 10010 600，20060 no permission
            if (!([10000, 10001, 10003, 10002, 10010, 600].includes(rtnCode) || [200, 200003, 200060].includes(code)) && res.url?.indexOf('/export') === -1 && res.url?.indexOf('assets/i18n') === -1 && res.url?.indexOf('svg') === -1 && res.url?.indexOf(environment.newsStaticUrl) === -1 && request.responseType !== 'blob') {
              this.message.create('error', rtnMsg || message);
            }
            // 如果非法token， 则回到登录页面重新登录
            if ([10001, 10003, 10002].includes(rtnCode) || code === 200003) {
              this.loginService.setUserData(null);
              localStorage.clear();
              this.router.navigate([`/home/index`]);
            }
            // 权限不足， 提示没有权限（当前页面显式声明静默时不弹提示）
            if (([10010, 600].includes(rtnCode) || code === 200060) && !this.sharedData.silentNoPermission) {
              this.message.create('error', this.translate.instant('NO_PERMISSION'));
            }
          }
        }
      }),
      catchError((err: HttpErrorResponse) => this.handleData(err))
    );
  }

  getOrgCode(router:string):string{
    const orgMapping = JSON.parse(localStorage.getItem('allOrgRoutes') || '{}');
    const userOrg = JSON.parse(localStorage.getItem('sales_org') || '[]');
    const orgList = orgMapping[`${router}`];
    if(window.location.href.includes("Salesportal/iam/cart/gettoken")) {
      return 'CN20-G1-40';
    }
    if (!orgList || orgList.length === 0) {
      return '';
    }
    if (orgList.includes('CN20-G1-40') && userOrg.includes('CN20-G1-40')) {
      return 'CN20-G1-40';
    }

    const firstMatchingOrg = orgList.find((org:any) => userOrg.includes(org));

    return firstMatchingOrg ? firstMatchingOrg : orgList[0];
  }

  private handleData(event: HttpResponse<any> | HttpErrorResponse,): Observable<any> {
    switch (event.status) {

      case 401: {
        this.router.navigate(['/login']);
        return of(event);
      }
      case 200: {
        return of(event);
      }
      default: {
        if (event instanceof HttpErrorResponse && event.error && event.error.rtnData && event.error.rtnData.msg) {
          this.message.create('error', event.error.rtnData.msg);
        }else{
          this.message.create('error', `This is a message of ${event.status + ": " + event.statusText}`);
        }
      }
    }
    return throwError(event);
  }
}
